// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__HWnQk","pageTitle":"style_pageTitle__3r9T_"};